<template>
  <!-- 统计数据分块显示,只显示，不做操作，C表示通用 -->
  <div class="statistic-block">
    <div v-for="(item, idx) in dataList" class="statistic-data" :key="idx" :style="{'--bgc': colorArr[idx % colorArr.length].bgColor, '--fgc': colorArr[idx % colorArr.length].fontColor}">
      <div class="statistic-icon">
        <yq-icon class="icon" :name="iconArr[idx % iconArr.length]"/>
      </div>
      <div class="statistic-info">
        <div class="name">{{ item.statisticName }}</div>
        <div class="count">{{ item.statisticCount || 0 }}</div>
      </div>

    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import YqIcon from "@/components/YqIcon.vue";

export default {
  props: {
    dataList: {
      // 使用{name: '', count: 0}
      default: () => [],
    },
    // 颜色，使用{bgColor, fontColor}形成一组，如果颜色数组不够将进行循环调用
    colorArr: {
      default: () => [{bgColor: "#eaf1ff", fontColor: "#2f6ded"}, {bgColor: "#e0f7fb", fontColor: "#06b6d4"}, {bgColor: "#f3e8ff", fontColor: "#8b5cf6"}, {bgColor: "#e8f9ee", fontColor: "#22c55e"}, {bgColor: "#fef3e2", fontColor: "#f59e0b"}]
    },
    // 图标，使用yqIcon组件，如果图标数组不够将进行循环调用
    iconArr: {
      default: () => ["element-ui_user", "element-ui_circle-check", "dingwei3", "element-ui_document", "element-ui_office-building"],
    }

  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "StaticBlock",
  components: {
    YqIcon
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.statistic-block{
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.statistic-data{
  flex: 1;
  min-width: 140px;
  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: white;
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
  padding: 16px 20px;
  transition: var(--transition);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100%;
  gap: 10px;
  .statistic-icon{
    font-size: 20px;
    background: var(--bgc);
    border-radius: 10px;
    color: var(--fgc);
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &::before{
    content: '';
    position: absolute;
    height: 100%;
    width: 4px;
    background: var(--fgc);
    z-index: 1;
    left: 0;
  }

  &:hover{
    transform: translateY(-4px);
    box-shadow: var(--card-shadow-hover);

    &::before{
      opacity: 1;
      animation: ripple 1s ease-out;
    }
  }

  // &:nth-child(2){
  //   background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  // }
  // &:nth-child(3){
  //   background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  // }
  // &:nth-child(4){
  //   background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  // }
  // &:nth-child(5){
  //   background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  // }
  // &:nth-child(6){
  //   background: linear-gradient(135deg, #30cfd0 0%, #330867 100%);
  // }
  // &:nth-child(7){
  //   background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  // }
  // &:nth-child(8){
  //   background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
  // }

  .count{
    font-size: 28px;
    font-weight: 700;
    color: black;
    margin-bottom: 4px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .name{
    color: #6b7280;
    font-size: 13px;
    //font-weight: 500;
  }
}
</style>